require('particles.js');

module.exports = function (id) {

  particlesJS(id, {
    particles: {
      number: {
        value: 100,
        density: {
          enable: true,
          value_area: 800
        }
      },
      color: {
        value: '#00b9ff'
      },
      shape: {
        type: 'circle',
        stroke: {
          width: 0
        },
        polygon: {
          nb_sides: 5
        }
      },
      opacity: {
        value: 0.4,
        random: true
      },
      size: {
        value: 3,
        random: true,
        anim: {
          enable: false,
          speed: 40,
          size_min: 0.1,
          sync: false
        }
      },
      line_linked: {
        enable: true,
        distance: 150,
        opacity: 0.2,
        width: 1,
        color: '#00b9ff'
      }
    },
    interactivity: {
      events: {
        onclick: {
          enable: false
        }
      }
    },
    retina_detect: true
  });

};